import { useState } from "react";
import Button from "../components/Button";
import FormInput from "../components/FormInput";
import API from "../services/api";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      alert("Completá usuario y contraseña");
      return;
    }
    setLoading(true);
    try {
      const res = await API.post("/auth/login", { username, password });
      localStorage.setItem("admin", JSON.stringify(res.data.admin));
      window.location.href = "/dashboard";
    } catch (error) {
      console.error(error);
      alert(
        error.response
          ? "Credenciales inválidas"
          : "No se pudo conectar con el servidor local",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cc-login">
      <div className="cc-login-card">
        <div className="cc-login-brand">
          <img
            src="/assets/ClinCash.png"
            alt="ClinCash"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        </div>
        <div className="cc-login-heading">
          <h1>Iniciar sesión</h1>
          <p>Accedé a tu panel de gestión financiera</p>
        </div>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            handleLogin();
          }}
        >
          <FormInput
            label="Usuario"
            type="text"
            placeholder="Ingresá tu usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <FormInput
            label="Contraseña"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            disabled={loading}
            style={{ width: "100%", height: 44 }}
          >
            {loading ? "Ingresando..." : "Iniciar sesión"}
          </Button>
        </form>
        <p className="cc-login-help">Acceso privado · ClinCash</p>
      </div>
    </div>
  );
}
export default Login;
